const blogpostData = [
    {
        id: "anne-margaret-roots",
        title: "Anne Margaret Roots",
        tabTitle: "RikVerse blog post",
        description: "... Rik's eulogy for his mother, Anne.",
        publishdate: "2026-08-19",
    },
    {
        id: "truths-tempered-in-doubt",
        title: "Truths Tempered in Doubt",
        tabTitle: "RikVerse blog post",
        description: "... A journey alongside AI to Damascus, and beyond.",
        publishdate: "2025-12-28",
    },
    {
        id: "how-not-to-train-your-reader",
        title: "How (not) to train your reader",
        tabTitle: "RikVerse blog post",
        description: "... The Road Not Taken is taken easier when I trust my audience as equals.",
        publishdate: "2025-12-14",
    },
    {
        id: "adventures-in-poetry-translation",
        title: "Adventures in poetry translation",
        tabTitle: "RikVerse blog post",
        description: "... Because sometimes I want to read the \"real\" Cavafy.",
        publishdate: "2025-12-06",
    },
    {
        id: "riks-sparky-little-rikverse-website",
        title: "Rik's Sparky Little RikVerse Website",
        tabTitle: "RikVerse blog post",
        description: "... Because Poetry is Fun!",
        publishdate: "2025-10-28",
    },
    {
        id: "most-dangerous-writing-of-all",
        title: "The most dangerous writing of all",
        tabTitle: "RikVerse blog post",
        description: "...There's more than one sort of profit in trauma.",
        publishdate: "2025-10-27",
    },
    {
        id: "face-writing",
        title: "Face writing",
        tabTitle: "RikVerse blog post",
        description: "... When a disability becomes a strength.",
        publishdate: "2025-10-26",
    },
    {
        id: "rik-careers",
        title: "When Rik grows up, what will he be?",
        tabTitle: "RikVerse blog post",
        description: "... What is life, if not work?",
        publishdate: "2025-10-25",
    },
    {
        id: "giving-books-away-for-free",
        title: "Why do you give your books away for free, Rik?",
        tabTitle: "RikVerse blog post",
        description: "... Seriously, why do that?",
        publishdate: "2014-12-02",
    },
    {
        id: "current-publishing-scene-hate",
        title: "Things I hate about the current publishing scene",
        tabTitle: "RikVerse blog post",
        description: "... An off-the-cuff list of things I'm currently hating about the publishing scene (with added profanity).",
        publishdate: "2013-07-16",
    },
    {
        id: "copyrights",
        title: "The RikVerse Creative Commons licences",
        tabTitle: "RikVerse blog post",
        description: "... Using Rik's poems in your own creative work, for free.",
        publishdate: "2012-01-01",
    },
    {
        id: "poet-five-step-plan",
        title: "Rik's five-step plan for becoming a poet",
        tabTitle: "RikVerse blog post",
        description: "... Rik's patented, guaranteed five step program on how to become a poet. In five steps.",
        publishdate: "2011-04-08",
    },
    {
        id: "ten-questions-poets-tech",
        title: "Ten questions for Poets about technology",
        tabTitle: "RikVerse blog post",
        description: "... How Rik thinks modern technology is affecting Poetry.",
        publishdate: "2010-06-15",
    },
    {
        id: "costs-of-independent-publishing",
        title: "The costs of independent publishing",
        tabTitle: "RikVerse blog post",
        description: "... How much it cost Rik to publish his book, 'The Gods in the Jungle'.",
        publishdate: "2010-03-18",
    },
    {
        id: "bored-of-poetry",
        title: "Why I'm bored of poetry",
        tabTitle: "RikVerse blog post",
        description: "... 'Why are you wasting my time with this?' is the most common question. 'Where's the goods, the payoff?' is another, and 'have you ever heard of having some fun?'",
        publishdate: "2009-09-01",
    },
    {
        id: "mapping-the-soq",
        title: "Mapping the SoQ (and beyond)",
        tabTitle: "RikVerse blog post",
        description: "... Mad ideas have started bubbling in Rik's head.",
        publishdate: "2009-01-26",
    },
    {
        id: "write-poems-for-audience",
        title: "Should a poet write poems for an audience?",
        tabTitle: "RikVerse blog post",
        description: "... In which Rik identifies some surprising audiences for whom Poets should write their poems.",
        publishdate: "2009-01-06",
    },
    {
        id: "alan-david-roots",
        title: "Alan David Roots",
        tabTitle: "RikVerse blog post",
        description: "... Rik's eulogy for his brother, Alan.",
        publishdate: "2008-10-18",
    },
    {
        id: "monkeys-learn-to-sing",
        title: "The Monkeys who Learned to Sing",
        tabTitle: "RikVerse blog post",
        description: "... What’s the point of inventing a better arrowhead if you can’t boast about it?",
        publishdate: "2007-10-01",
    },
    {
        id: "all-is-vanity",
        title: "All is vanity",
        tabTitle: "RikVerse blog post",
        description: "... Rik's reasons for self-publishing his poetry are not quite the same as for other people.",
        publishdate: "2007-07-02",
    },
    {
        id: "14-mins-to-save-internet-poetry",
        title: "We've only got 14 minutes to save internet poetry!",
        tabTitle: "RikVerse blog post",
        description: "... How can we improve the reputation of internet poetry?",
        publishdate: "2007-06-21",
    },
    {
        id: "poets-in-residence",
        title: "Poets-in-residence? Or parasites-at-lunch?",
        tabTitle: "RikVerse blog post",
        description: "... Spend the poetry pound on the kiddies, not the poets. You know it makes sense.",
        publishdate: "2007-01-14",
    },
    {
        id: "posterity",
        title: "Posterity",
        tabTitle: "RikVerse blog post",
        description: "... But what is this Posterity Thing that people think is a good reason to publish their work?",
        publishdate: "2006-05-12",
    },
    {
        id: "why-of-poetry-3",
        title: "The Why of Poetry (part 3)",
        tabTitle: "RikVerse blog post",
        description: "... Patronage and the poet.",
        publishdate: "2006-03-09",
    },
    {
        id: "why-of-poetry-2",
        title: "The Why of Poetry (part 2)",
        tabTitle: "RikVerse blog post",
        description: "... Concerning 'Social' and 'Commercial' poetry.",
        publishdate: "2006-03-07",
    },
    {
        id: "why-of-poetry-1",
        title: "The Why of Poetry (part 1)",
        tabTitle: "RikVerse blog post",
        description: "... Rik tries to work out why the poetry market sucks.",
        publishdate: "2006-03-06",
    },
    {
        id: "mad-ideas",
        title: "Mad ideas",
        tabTitle: "RikVerse blog post",
        description: "... Where Rik counts up the mad ideas he's had over the years for promoting online poetry - and considers future ventures.",
        publishdate: "2006-02-24",
    },
    {
        id: "every-poem-i-write",
        title: "Every poem I write",
        tabTitle: "RikVerse blog post",
        description: "... Some of the poems that Rik enjoys reading the most are Flawed Poems",
        publishdate: "2006-01-22",
    },
    {
        id: "nine-poet-questions",
        title: "Nine Poet Questions",
        tabTitle: "RikVerse blog post",
        description: "... Rik discovers some profound poetical questions online and attempts to answer them.",
        publishdate: "2005-12-24",
    },
    {
        id: "poetry-journals",
        title: "Poetry journals",
        tabTitle: "RikVerse blog post",
        description: "... On the birth of Magma Magazine, and Rik's small part in that miracle.",
        publishdate: "2005-12-20",
    },
    {
        id: "poetic-corruption",
        title: "(Poetic) Corruption",
        tabTitle: "RikVerse blog post",
        description: "... In the world of poetry there is not much money to be made. Superstars are far and few between.",
        publishdate: "2005-12-01",
    },
    {
        id: "my-problems-with-like",
        title: "My problems with \"like\"",
        tabTitle: "RikVerse blog post",
        description: "... Rik has always had a bit of a problem with similes and metaphors.",
        publishdate: "2005-11-17",
    },
    {
        id: "fantasy-publishing-internet-poetry",
        title: "Fantasy publishing: a brief history of internet poetry",
        tabTitle: "RikVerse blog post",
        description: "... In which Rik plays a game of fantasy publishing.",
        publishdate: "2005-09-03",
    },
    {
        id: "new-sincerity",
        title: "New Sincerity?",
        tabTitle: "RikVerse blog post",
        description: "... Can a turbine engine be sincere? Is a dying leaf sincere?",
        publishdate: "2005-08-22",
    },
];

export default blogpostData;
